import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { normalizeCanonicalPath } from '../seoConfig';

const CanonicalRedirect = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const canonicalPath = normalizeCanonicalPath(location.pathname);

        if (canonicalPath !== location.pathname) {
            navigate(
                {
                    pathname: canonicalPath,
                    search: location.search,
                    hash: location.hash,
                },
                { replace: true }
            );
        }
    }, [location.pathname, location.search, location.hash, navigate]);

    return null;
};

export default CanonicalRedirect;
